module.exports = __webpack_public_path__ + "media/promo/lum2021/images/4thm-93032c59601cf9200e8c6574f8ff9857.jpg";